import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-navigation-arrow-to-bottom-icon',
  templateUrl: './navigation-arrow-to-bottom.component.html'
})
export class NavigationArrowToBottomComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
